import { Box, CircularProgress } from "@mui/material";
import LoaderLogo from "../../assets/images/Layout/goalngo-loader-logo.png";
import { colors } from "../../theme/palette";

const MainLoader = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "inline-flex",
        }}
      >
        <CircularProgress size={400} thickness={1} sx={{ color: "#039103" }} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <img src={LoaderLogo} width="250px" height="250px" />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLoader;
